export const starLv = [
  {
    key: "1 ~ 2星級",
    value: "1-2",
  },
  {
    key: "3 ~ 4星級",
    value: "3-4",
  },
  {
    key: "5星級",
    value: "5",
  },
];
